<template>
    <div>
        <q-modal v-model="show_report" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}" no-backdrop-dismiss no-esc-dismiss>
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="show_report = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ title }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <q-list separator highlight link>
                        <q-item v-for="(question, index) in questions" :key="index" @click.native="showQuestion(question)">
                            <q-item-main
                                :label="question.title"
                                label-lines="1"
                                :sublabel="`${$t('user_answers')}: ${question.qty_user_answered}`"
                                sublabel-lines="1"
                            />
                        </q-item>
                    </q-list>
                </div>
            </q-modal-layout>
        </q-modal>

        <user-answers :question="question" :show_question="show_question" :title="title" :id="id" @hide_user_answers="hideUserAnswers" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UserAnswers from 'components/admin/surveys/UserAnswers'

export default {
    props: ['show_report_survey', 'id', 'status', 'title'],

    components: {
        'user-answers': UserAnswers
    },

    data() {
        return {
            questions: [],
            question: {},
            show_question: false
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },

        show_report: {
            get() {
                return this.show_report_survey
            },
            set() {
                this.$emit('hide_report', '')
            }
        },
    },

    methods: {
        fetchData() {
            this.$q.loading.show()

            this.$axios.get(`/admin_surveys/surveys/${this.id}/survey_report_questions/`, this.getHeader)
            .then(response => {
                this.questions = response.data
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        showQuestion(question) {
            if (question.qty_user_answered > 0) {
                this.question = question
                this.show_question = true
            }
        },

        hideUserAnswers() {
            this.show_question = false
            this.question = {}
        }
    },

    watch: {
        show_report: function() {
            if (this.show_report) {
                this.fetchData()
            }
        }
    },
}
</script>

<style>

</style>
